<template>
  <div>
    <div class="testimonial-slider__single wow move-up tarjeta-curso">
      <a
        style="width: 100%"
        :href="
          'https://forumapp.progrentis.com/cartelera-cursos/' +
          sanitizeTitle(curso.nombre) +
          '/' +
          curso._id
        "
      >
        <div
          class="testimonial-slider__media item-img text-center"
          :style="`height: 230px; background-image:url(${curso.img});
                background-size: cover; border-radius: 6px 6px 0 0`"
        >
          <span
            v-if="curso.formato_curso === 'Live'"
            data-v-3b81fe2c=""
            class="
              badge badge-glow
              formatoCurso
              formato-curso-proximamente
              badge-warning badge-pill
              float-right
              mt-3
              mr-3
            "
            ><svg
              data-v-3b81fe2c=""
              xmlns="http://www.w3.org/2000/svg"
              width="14px"
              height="14px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mr-25 feather feather-radio"
            >
              <circle data-v-3b81fe2c="" cx="12" cy="12" r="2"></circle>
              <path
                data-v-3b81fe2c=""
                d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
              ></path>
            </svg>
            Próximanente
          </span>
          <span
            v-if="curso.formato_curso === 'Campus'"
            data-v-3b81fe2c=""
            class="
              badge badge-glow
              formatoCurso
              formato-curso-campus
              badge-pill
              float-right
              mt-3
              mr-3
            "
            ><svg
              data-v-58638f76=""
              xmlns="http://www.w3.org/2000/svg"
              width="14px"
              height="14px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mr-25 feather feather-play-circle"
            >
              <circle data-v-58638f76="" cx="12" cy="12" r="10"></circle>
              <polygon
                data-v-58638f76=""
                points="10 8 16 12 10 16 10 8"
              ></polygon>
            </svg>
            {{ curso.formato_curso }}
          </span>
          <span
            v-if="curso.formato_curso === 'Open'"
            data-v-3b81fe2c=""
            class="
              badge badge-glow
              formatoCurso
              formato-curso-open
              badge-pill
              float-right
              mt-3
              mr-3
            "
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="14px"
              height="14px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mr-25 feather feather-play-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polygon points="10 8 16 12 10 16 10 8"></polygon>
            </svg>
            {{ curso.formato_curso }}
          </span>
          <span
            v-if="curso.formato_curso === 'Live_streaming'"
            data-v-3b81fe2c=""
            class="
              badge badge-glow
              formatoCurso
              formato-curso-open
              badge-pill
              float-right
              mt-3
              mr-3
            "
            ><svg
              data-v-3b81fe2c=""
              xmlns="http://www.w3.org/2000/svg"
              width="14px"
              height="14px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mr-25 feather feather-radio"
            >
              <circle data-v-3b81fe2c="" cx="12" cy="12" r="2"></circle>
              <path
                data-v-3b81fe2c=""
                d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
              ></path>
            </svg>
            Live
          </span>
        </div>
      </a>
      <div class="testimonial-slider__text">
        <div class="col d-flex justify-content-end">
          <span v-if="curso.precio === '0'" class="precio"> GRATIS </span>
          <span v-else class="precio">
            ${{ curso.precio }}
          </span>
        </div>
      </div>
      <div
        class="
          testimonial-slider__author
          d-flex
          align-items-start
          flex-column
          mb-5
        "
      >
        <div class="col">
          <h6 class="name">
            <a
              :href="
                'https://forumapp.progrentis.com/cartelera-cursos/' +
                sanitizeTitle(curso.nombre) +
                '/' +
                curso._id
              "
              >{{ curso.nombre }}</a
            >
          </h6>
        </div>
        <div class="col">
          <h6 class="categoria">{{ curso.categoria[0].nombre }}</h6>
        </div>
        <!-- <span class="designation">WEB DESIGNER</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TarjetaCurso",
  props: {
    curso: {
      type: Object,
    },
  },
  methods: {
    sanitizeTitle(titulo) {
      let slug = "";
      // Change to lower case
      const titleLower = titulo.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      
      slug = slug.replace(/[¿=]/g, "");

      slug = slug.replace(/[?=]/g, "");
      
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>

<style lang="scss" scoped>
.testimonial-slider__media,
.testimonial-slider__text {
  margin-bottom: 10px;
}
.formatoCurso {
  color: #fff;
}
.formato-curso-proximamente {
  box-shadow: 0 0 10px #ff9f43;
  background-color: #ff9f43;
}
.formato-curso-campus {
  background-color: #28c76f;
  box-shadow: 0 0 10px #28c76f;
}
.formato-curso-open {
  background-color: #7367f0;
  box-shadow: 0 0 10px #7367f0;
}
.formato-curso-live {
  background-color: #ed2a2f;
  box-shadow: 0 0 10px #ed2a2f;
}

.tarjeta-curso {
  padding: 0;
  min-height: 450px;

  .testimonial-slider__media {
    .img-fluid {
      border-radius: 6px;
    }
  }

  .precio {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    text-align: right;
    color: #2c2e30;
  }

  .name {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 21px;
    color: #2c2e30;
    text-align: left;
  }
  .categoria {
    font-family: "Mulish";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #6a7680;
    text-align: left;
  }
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .tarjeta-curso {
    height: 400px;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>